export const COLLECT_PERIODS_TYPES = {
  LOAD_COLLECT_PERIODS: "LOAD_COLLECT_PERIODS",
  SET_COLLECT_PERIODS: "SET_COLLECT_PERIODS",
  CLEAR_COLLECT_PERIODS: "CLEAR_COLLECT_PERIODS",
  // new collect period
  NEW_COLLECT_PERIOD: "NEW_COLLECT_PERIOD",
  SEND_NEW_COLLECT_PERIOD: "SEND_NEW_COLLECT_PERIOD",
  SET_NEW_COLLECT_PERIOD: "SET_NEW_COLLECT_PERIOD",

  EDIT_COLLECT_PERIOD: "EDIT_COLLECT_PERIOD",
  SET_EDITED_COLLECT_PERIOD: "SET_EDITED_COLLECT_PERIOD",
  DELETE_COLLECT_PERIOD: "DELETE_COLLECT_PERIOD",
  HANDLE_COLLECT_PERIODS_INPUTS: "HANDLE_COLLECT_PERIODS_INPUTS",
};
